<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="baseView.mode == 'create' ? true : false"
    :backButtonRoute="backButtonRoute"
    ref="journal"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :warningSummary="warningSummary"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";
import { JournalDetailServices } from "../../_services/api/finance/journalDetail";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { DivisionService } from "../../_services/api/sales/division.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { ProductService } from "../../_services/api/products/product.service";
import { getFactorByCode } from "../../_store/helpers";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      dataModel: {
        CompanyCode: undefined,
        MinDate: undefined,
        MaxDate: undefined,
        AccountingPeriod: undefined,
        JournalCode: undefined,
        DateIn: new Date(),
        Status: "D",
      },
      reload: false,
      validationSummary: [],
      goBackRoute: "/journals",
      serverError: {},
      warningSummary: [],
      journalItems: [
        // {
        //   GLChartCode: undefined,
        //   GLChartDescription: undefined,
        //   BranchCode: undefined,
        //   BranchDescription: undefined,
        //   DivisionCode: undefined,
        //   DivisionDescription: undefined,
        //   Comment: undefined,
        //   Amount: 0,
        // },
      ],

      branchDataSourceItems: [],
      divisionDataSourceItems: [],
      glChartDataSourceItems: [],
      defaultBranchCode: undefined,
      defaultDivisionCode: undefined,
    };
  },

  async created() {
    await this.$store.dispatch("screenFactors/getFactors", [65, 66]);
    this.defaultBranchCode = getFactorByCode(65).Factorc;
    this.defaultDivisionCode = getFactorByCode(66).Factorc;

    this.journalItems.push({
      GLChartCode: undefined,
      GLChartDescription: undefined,
      BranchCode: this.defaultBranchCode,
      BranchDescription: undefined,
      DivisionCode: this.defaultDivisionCode,
      DivisionDescription: undefined,
      Comment: undefined,
      Amount: 0,
    });
    this.initialized();
  },
  watch: {
    $route(to){
      if(to.path == '/journals/create'){
        location.reload();
      }
    }
  },
  async mounted() {},
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },

  computed: {
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    getDataModel() {
      return this.dataModel;
    },
    backButtonRoute() {
      return this.goBackRoute;
    },
    getScreenJson() {
      var screenJson = {
        title: "Journal",
        endpoint: {
          primary: this.baseView.mode !== "create" ? "Journal" : undefined,
          filter: `JournalCode eq ${this.baseView.id}`,
          postProcess: this.JournalPostProcess,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint:
                this.baseView.mode == "create" ? undefined : "JournalDetail",
              filter:
                this.baseView.mode !== "create"
                  ? ["JournalCode eq " + this.baseView.id]
                  : [],
              allowGrouping: false,
              localDataList: this.baseView.mode == "create" ? true : false,
              items: this.journalItems,
              postProcessCallback:
                this.baseView.mode == "create"
                  ? undefined
                  : this.journalDetailPostProcess,
            },
            noDataMessage: {
              // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
              // review: {
              //   addNew: {
              //     class: "no-data",
              //     title: "No Credit Lines",
              //     message: "Get Started, Add a Credit Line",
              //   },
              // },

              "product-list": {
                addNew: {
                  class: "no-data",
                  title: "No Product Lines",
                  message: this.dataModel.SupplierCode
                    ? "Products will show if the Supplier is a supplier of the product.  Head over to the Product screen to nominate the suppiler of the product."
                    : "Products will show when a Supplier is selected.",
                },
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: true,
          },
          columns:
            this.baseView.mode == "create"
              ? [
                  {
                    screenField: "GLChart",
                    dataField: "GLChartCode",
                    label: "Account",
                    cellTemplate: "SelectField",
                    allowUpdate: true,
                    dataSourceConfig: {
                      data: this.glChartDataSourceItems,
                    },
                  },
                  {
                    screenField: "Branch",
                    dataField: "BranchCode",
                    gridDataField: undefined,
                    cellTemplate: "SelectField",
                    allowUpdate: true,
                    dataSourceConfig: {
                      data: this.branchDataSourceItems,
                    },
                  },
                  {
                    screenField: "Division",
                    dataField: "DivisionCode",
                    gridDataField: undefined,
                    cellTemplate: "SelectField",
                    allowUpdate: true,
                    dataSourceConfig: {
                      data: this.divisionDataSourceItems,
                    },
                  },
                  {
                    screenField: "Comments",
                    dataField: "Comment",
                    // allowEditing: this.baseView.mode != "review",
                    showEditorAlways: true,
                    allowSearch: false,
                    allowSorting: false,
                    minWidth: 250,
                    editCellTemplate: "EditableTextArea",
                  },
                  {
                    screenField: "FXPrice",
                    dataField: "Amount",
                    label: "Amount",
                    minWidth: 150,
                    type: "EditableDecimal",
                    showEditorAlways: true,
                    allowFiltering: false,
                    allowSearch: false,
                    allowSorting: false,
                  },
                  {
                    dataField: "ActionAddNew",
                    label: "",
                    width: 50,
                    minWidth: 50,
                    cellTemplate: "ActionAddNew",
                    // visible: this.visibleAddNew,
                    cssClass: "class-custom-btn",
                  },
                  {
                    dataField: "ActionDelete",
                    label: "",
                    width: 50,
                    minWidth: 50,
                    cellTemplate: "ActionDelete",
                    // visible: this.visibleAddNew,
                    cssClass: "class-custom-btn",
                  },
                  {
                    dataField: "ActionCopy",
                    label: "",
                    width: 50,
                    minWidth: 50,
                    cellTemplate: "ActionCopy",
                    // visible: this.baseView.mode != "review",
                    cssClass: "class-custom-btn",
                  },
                ]
              : [
                  {
                    // TODO
                    screenField: "GLChart",
                    dataField: "GLChartCode",
                    label: "Account",
                    // cellTemplate: "SelectField",
                    allowUpdate: false,
                  },
                  {
                    screenField: "Branch",
                    dataField: "BranchCode",
                    gridDataField: undefined,
                    // cellTemplate: "SelectField",
                    allowUpdate: false,
                  },
                  {
                    screenField: "Division",
                    dataField: "DivisionCode",
                    gridDataField: undefined,
                    // cellTemplate: "SelectField",
                    allowUpdate: false,
                  },
                  {
                    screenField: "Comments",
                    dataField: "Comment",
                    // allowEditing: this.baseView.mode != "review",
                    showEditorAlways: true,
                    allowSearch: false,
                    allowSorting: false,
                    minWidth: 250,
                    editCellTemplate: "EditableTextArea",
                  },
                  {
                    screenField: "FXPrice",
                    dataField: "Amount",
                    label: "Amount",
                    minWidth: 150,
                    // type: "EditableDecimal",
                    // showEditorAlways: true,
                    allowFiltering: false,
                    allowSearch: false,
                    allowSorting: false,
                  },
                ],

          valueChangedEventListners: [
            {
              dataField: "GLChartCode",
              listner: (e, lineData) => {
                lineData.data.GLChartCode = e.itemData.ComputedStringCode;
                lineData.data.GLChartDescription = e.itemData.Description;
              },
            },
            {
              dataField: "BranchCode",
              listner: (e, lineData) => {
                lineData.data.BranchCode = e.itemData.Code;
                lineData.data.BranchDescription = e.itemData.Description;
              },
            },
            {
              dataField: "DivisionCode",
              listner: (e, lineData) => {
                lineData.data.DivisionCode = e.itemData.Code;
                lineData.data.DivisionDescription = e.itemData.Description;
              },
            },
            {
              dataField: "Comment",
              listner: (e, lineData) => {
                lineData.data.Comment = e.value;
              },
            },
            {
              dataField: "Amount",
              listner: (e, lineData) => {
                lineData.data.Amount = e.value;
              },
            },
            {
              dataField: "ActionAddNew",
              listner: (e, lineData) => {
                if (!e) return;
                this.addNewRow(lineData, "add-new");
              },
            },
            {
              dataField: "ActionDelete",
              listner: (e, lineData) => {
                this.deleteRow(e, lineData);
              },
            },
            {
              dataField: "ActionCopy",
              listner: (e, lineData) => {
                if (!e) return;
                this.addNewRow(lineData, "copy-line");
              },
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              dataField: "Amount",
              screenField: "FXTotal",
              location: "right",
              value: 0,
              label: "Balance",
              // format: "Decimal-16-4C",
            },
          ],
        },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerToolbar: {
            screenName: "Journals - Review",
            pdf: true,
            audit: false,
            status: true,
            notes: false,
            save: this.baseView.mode == "review" ? false : true,
            saveCallback: this.saveJournal,
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      editorOptions: {
                        min: this.dataModel.MinDate,
                        max: this.dataModel.MaxDate,
                        allowUpdate: true,
                      },
                      required: true,
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "Reversed",
                      label: {
                        text: "Reverse",
                      },
                      editorType: "dxCheckBox",
                      editorOptions: {
                        // onValueChanged: () => {
                        //   this.onChangeFXFreight();
                        // },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField:
                  this.baseView.mode == "create" ? undefined : "JournalCode",
                text:
                  this.baseView.mode == "create"
                    ? "Create Journal"
                    : "Journal #",
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
        },
      };
    },
  },
  methods: {
    JournalPostProcess(data) {
      data.Reversed = data.Reversed == "Y" ? true : false;
      return data;
    },
    async saveJournal(data, GridItems) {
      let total = 0;
      for (let i = 0; i < GridItems.length; i++) {
        total += GridItems[i].Amount;
      }
      if (GridItems.length < 2) {
        this.validationSummary = [];
        this.validationSummary.push({
          message: `Journal requires at least 2 detail rows.`,
        });
      } else if (total != 0) {
        this.validationSummary = [];
        this.validationSummary.push({
          message: `The journal must balance to 0.00. Please check the  amounts before attempting to save again.`,
        });
      } else {
        this.setLoading = true;
        let JournalDetails = GridItems.map((gridItem) => {
          return {
            BranchCode: gridItem.BranchCode,
            DivisionCode: gridItem.DivisionCode,
            AccountCode: parseInt(gridItem.GLChartCode),
            CompanyCode: this.dataModel.CompanyCode,
            Comment: gridItem.Comment === undefined ? "" : gridItem.Comment,
            Amount: parseFloat(gridItem.Amount),
          };
        });
        let Journal = {
          AccountingPeriod: this.getDataModel.AccountingPeriod,
          DateIn: data.DateIn,
          Reverse: data.Reversed ? "Y" : "N",
          JournalDetails,
        };

        await JournalDetailServices.saveJournalDetail(Journal)
          .then(({ data }) => {
            this.setLoading = false;
            this.$notify(`Journal ${data.Code} saved successfully`, "success");

            this.setIgnoreRouteChangeConfirmation();
            this.$router
              .push({
                path: `/journals/review/${data.Code}`,
              })
              .then(() => {
                this.reload = true;
                this.initialized();
              });
          })
          .catch((err) => {
            this.serverError = {
              err,
              msg: "Journal save failed",
              time: new Date().getTime(),
            };

            this.setLoading = false;
          });
      }
    },
    journalDetailPostProcess(data) {
      data.forEach((element) => {
        element.ComputedStringCode = element.AccountCode;
        element.Description = element.AccountDescription;
        element.GLChartCode = element.AccountCode.toString();
      });

      return data;
    },

    async initialized() {
      this.dataModel.JournalCode = this.baseView.id;
      this.setLoading = true;
      if (this.baseView.mode == "create") {
        await this.setBranchDataSourceItems();
        await this.setDivisionDataSourceItems();
        await this.setGLChartDataSourceItems();
        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
        await JournalDetailServices.getActiveAccountPeriod().then(
          ({ data }) => {
            this.dataModel.MinDate = data.value[0].DateStart;
            this.dataModel.MaxDate = data.value[0].DateEnd;
            this.dataModel.AccountingPeriod = data.value[0].AccountingPeriod;
          }
        );
        await DefaultCompanyBranchDivisionService.getDefault().then(
          ({ data }) => {
            this.dataModel.CompanyCode = data.value[0].CompanyCode;
          }
        );
      } else {
        setTimeout(() => {
          this.reload = false;
          this.loaded = true;
          this.setLoading = false;
        }, 250);
      }
    },
    async deleteRow(e, lineData) {
      if (!e) return;
      // var gridInstance =
      //   this.$refs["journal"].$refs["transactionGrid"].getGridInstance();
      // gridInstance.deleteRow(lineData.rowIndex);

      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this line ?",
        "Delete Record"
      );

      if (confirmDelete) {
        this.journalItems.splice(lineData.rowIndex, 1);

        if (this.journalItems.length == 0) {
          this.journalItems.push({
            GLChartCode: undefined,
            GLChartDescription: undefined,
            BranchCode: this.defaultBranchCode,
            BranchDescription: undefined,
            DivisionCode: this.defaultDivisionCode,
            DivisionDescription: undefined,
            Comment: undefined,
            Amount: 0,
          });
        }
      }
    },
    addNewRow(lineData, type) {
      this.validationSummary = [];
      var validation = [];

      if (!lineData.data.GLChartCode)
        validation.push({
          message: "Account field is required",
        });

      if (!lineData.data.BranchCode)
        validation.push({
          message: "Branch field is required",
        });

      if (!lineData.data.DivisionCode)
        validation.push({
          message: "Division field is required",
        });

      if (!lineData.data.Amount)
        validation.push({
          message: "Amount field is required",
        });

      if (validation.length > 0) this.validationSummary = validation;
      else {
        if (type == "add-new")
          this.journalItems.push({
            GLChartCode: undefined,
            GLChartDescription: undefined,
            BranchCode: this.defaultBranchCode,
            BranchDescription: undefined,
            DivisionCode: this.defaultDivisionCode,
            DivisionDescription: undefined,
            Comment: undefined,
            Amount: 0,
          });
        else {
          var copyItem = { ...lineData.data };
          this.journalItems.push(copyItem);
        }
      }
    },
    async setDivisionDataSourceItems() {
      let divisionDS = DivisionService.dataSourceConfig("api/Division", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });

      this.divisionDataSourceItems = await divisionDS.load();
    },
    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });

      this.branchDataSourceItems = await branchDS.load();
    },
    async setGLChartDataSourceItems() {
      let branchDS = ProductService.dataSourceConfig("api/GLChart", {
        filter: [["Inactive", "=", "N"], "and", ["Status", "=", "A"]],
        sort: [{ selector: "ComputedStringCode", asc: true }],
        preventPagination: true,
      });

      this.glChartDataSourceItems = await branchDS.load();
    },
  },
};
</script>
